import { Grid, useMediaQuery } from "@mui/material";
import { Labeled, TextField } from "react-admin";

import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";

const PersonalDataSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <>
      <SectionTitle
        paddingY={2}
        title="Лични данни"
        textAlign="center"
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Име">
            <TextField
              source="firstName"
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Фамилия">
            <TextField
              source="lastName"
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Телефон за контакт">
            <TextField
              source="phone"
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Студентски имейл">
            <TextField
              source="email"
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Среден успех">
            <TextField
              source="averageGrade"
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="IBAN">
            <TextField
              source="iban"
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Времетраене на досегашния Еразъм (в дни)">
            <TextField
              source="previousErasmusDurationDays"
              emptyText="-"
            />
          </Labeled>
        </Grid>
      </Grid>
    </>
  );
};

export default PersonalDataSection;
